<template>
  <div class="psr-navbar">
    <v-toolbar class="teal darken-4" dark dense fixed>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <!-- <v-toolbar-title v-text="title"></v-toolbar-title> -->
      <img style="width:150px;height:40px;margin-left:1vw;" src="https://cdnblobendpoint.azureedge.net/bezzina-static/img/bezzina-logo.png" alt="Bezzina" @click="$router.push('/')">
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-for="(link, index) in links" :key="index" @click="$router.push(link.path)" slot="activator" flat>
          <v-icon>{{ link.icon }}</v-icon>{{ link.name }}
        </v-btn>
        <v-btn slot="activator" @click="$router.push('/admin/register')" v-if="isLoggedIn" flat><v-icon>{{ "fa fa-user-plus" }}</v-icon> {{ "Register" }}</v-btn>
        <v-btn slot="activator" @click="logoutUser" v-if="isLoggedIn" flat><v-icon>{{ "fa fa-sign-out" }}</v-icon> {{ "Logout" }}</v-btn>
      </v-toolbar-items>
      </v-toolbar>
      <v-navigation-drawer class="hidden-md-and-up" v-model="drawer" temporary fixed floating>
      <!-- <v-navigation-drawer permanent dark clipped class="hidden-md-and-down"> -->
        <v-divider></v-divider>
        <v-list dense class="pt-0">
          <v-list-tile v-for="item in items" :key="item.title" @click="$router.push(item.path)">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer> 
  </div>
  </template>

  <script>
  import { mapGetters, mapActions } from 'vuex'
  import Api from '@/api'

  export default {
    data () {
      return {
        title: 'Bezzina',
        links: [
          {
            name: 'Dashboard',
            path: '/admin',
            icon: 'fa fa-home'
          }
        ],
        drawer: null,
        items: [
          { title: 'Dashboard', icon: 'dashboard', path: '/admin' },
          { title: 'About', icon: 'dashboard', path: '/admin/about' },
          { title: 'Design', icon: 'dashboard', path: '/admin/design' },
          { title: 'Experience', icon: 'dashboard', path: '/admin/experience' },
          { title: 'Projects', icon: 'dashboard', path: '/admin/project' },
          { title: 'Slider Images', icon: 'dashboard', path: '/admin/slider-images' },
          { title: 'Image Gallery', icon: 'dashboard', path: '/admin/image-gallery' },
          { title: 'Company Contact', icon: 'dashboard', path: '/admin/company-contact' },
          { title: 'Social Links', icon: 'dashboard', path: '/admin/social-links' }
        ]
      }
    },
    computed: {
      ...mapGetters({
        isLoggedIn: 'adminUser/getLoginStatus'
      })
    },
    methods: {
      ...mapActions({
        logout: 'adminUser/logout'
      }),
      logoutUser () {
        const path = '/admin/logout'
        const data = {}
        Api.post(path, data)
          .then(response => {
            if (response.data.status === 0) {
              this.$router.push('/admin/login')
              this.logout()
            } else {
              this.$swal(response.data.message)
              this.$router.push('/admin/login')
              this.logout()
            }
          })
          .catch(error => {
            this.$swal(error.toString().substring(0, 100))
            this.$router.push('/admin/login')
            this.logout()
          })
      }
    }
  }
  </script>

  <style>
  .psr-navbar {
    /*font-family: 'Roboto', sans-serif;*/
    font-family: 'Lato', sans-serif;
    /*font-family: 'Source Sans Pro', sans-serif;*/
  }
</style>


// WEBPACK FOOTER //
// src/components/DashBoardNav.vue